import { useDispatch } from 'react-redux';

import { showNotification } from '../redux/notificationsSlice';

const useNoty = () => {
  const dispatch = useDispatch();

  const transformParams = (params) => {
    if (typeof params === 'string') {
      return {
        value: params,
      };
    }
    return params;
  };

  const successNoty = (params) => {
    dispatch(
      showNotification({
        type: 'success',
        ...transformParams(params),
      }),
    );
  };

  const infoNoty = (params) => {
    dispatch(
      showNotification({
        type: 'info',
        ...transformParams(params),
      }),
    );
  };

  const warningNoty = (params) => {
    dispatch(
      showNotification({
        type: 'warning',
        ...transformParams(params),
      }),
    );
  };

  const errorNoty = (params) => {
    dispatch(
      showNotification({
        type: 'error',
        ...transformParams(params),
      }),
    );
  };

  return {
    success: successNoty,
    info: infoNoty,
    warning: warningNoty,
    error: errorNoty,
  };
};

export default useNoty;
